/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_item" | "PdpRespTradeIconBubbles_item">;
    readonly " $refType": "PdpRespIconBubblesWrapper_item";
};
export type PdpRespIconBubblesWrapper_item$data = PdpRespIconBubblesWrapper_item;
export type PdpRespIconBubblesWrapper_item$key = {
    readonly " $data"?: PdpRespIconBubblesWrapper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_item"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'f772fc672a6929d8b888ed1950bbfa1e';
export default node;
